var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow"),React.createElement("path",{"id":"a","d":"M-35.6,16.09","transform":"translate(-0.4)","fill":"none","key":1}),React.createElement("path",{"d":"M.4,2.25H20.15v1H.4Z","transform":"translate(-0.4)","fill":"#1a1919","fillRule":"evenodd","key":2}),React.createElement("path",{"d":"M17.56,4.73,20.28,2l.71.7L18.27,5.43Z","transform":"translate(-0.4)","fill":"#1a1919","fillRule":"evenodd","key":3}),React.createElement("path",{"d":"M17.56.71,20,3.18l.7-.7L18.27,0Z","transform":"translate(-0.4)","fill":"#1a1919","fillRule":"evenodd","key":4})]);
}

Arrow.defaultProps = {"id":"Слой_1","data-name":"Слой 1","width":"20.59","height":"5.43","viewBox":"0 0 20.59 5.43"};

module.exports = Arrow;

Arrow.default = Arrow;
